const BASE_URL = process.env.REACT_APP_BASE_URL

const getToken = (): string => {
    const token = localStorage.getItem("access_token");
    if (!token) {
        throw new Error("Missing access token");
    }
    return token
}

export type ResponseTypes = {
    message: string;
    httpStatus: string;
    data?: any;
    errorCode?: number;
    errorMessage?: number;
    access_token?: string
}

export type Subscriber = {
    name: string
    whatsappContact: string
    whatsapp: boolean
    smsContact: string
    sms: boolean
    viberContact: string
    viber: boolean
    email: string
}

type CustomSubscriber = {
    name: string
    workflowId: string
    subscribers: Subscriber[]
}

export const APIGetAllCustomSubscribers = async (workflowId: string): Promise<{status: boolean; message: string; data?: CustomSubscriber[]}> => {
    const URL: string = `${BASE_URL}/ew/api/v1/getAllCustomSubscribers?workflowId=${workflowId}`
    const HEADER: RequestInit = {
        method: "GET",
        headers: {
            Authorization: `Bearer ${getToken()}`,
            "Content-Type": "application/json",
        }
    }

    try
    {
        const response = await fetch(URL, HEADER)
        const responseJson = await response.json() as ResponseTypes

        if (!response.ok)
        {
            return { status: false, message: 'custom subscribers fetching error' }
        }
        return { status: true, message: 'successfully fetched custom subscribers', data: responseJson.data as CustomSubscriber[] } 
    }
    catch (error)
    {
        console.error("Error fetching custom subscribers:", error)
        return { status: false, message: 'custom subscribers fetching error' }
    }
}